import React from 'react';

import { ExclamationCircleOutlined } from '@ant-design/icons';
import { App, ModalFuncProps } from 'antd';

export default function useCustomType1Modal() {
  const { modal } = App.useApp();

  const defaultIcon = <ExclamationCircleOutlined />;

  function confirm(config: ModalFuncProps) {
    const fixConfig = {
      wrapClassName: 'CustomConfirmModal CustomType1Modal',
      centered: true,
      onCancel: () => {},
    };
    return modal.confirm({
      ...config,
      icon: config.icon || defaultIcon,
      width: config.width || 416,
      ...fixConfig,
    });
  }
  return [confirm] as [typeof confirm];
}
